import { ProcessFieldBase, ProcessFieldMap } from '@shared/types/process';
import { isDeepEqual } from '@shared/util/isDeepEqual';

import { LatLngBoundsExpression, LatLngExpression } from 'leaflet';
import { FC, memo, useEffect, useMemo } from 'react';
import { useMap } from 'react-leaflet';

// import { MapMarker } from './mapFunctions/mapFunctions';

interface Props {
    field: ProcessFieldBase & ProcessFieldMap;
}
const OptionMap: FC<Props> = ({ field }) => {
    const options = useMemo(() => field.options, [field.options]);
    // const icon = L.icon({
    //     iconUrl: MapMarker('#4447c9'),
    //     iconSize: [30, 30],
    //     iconAnchor: [15, 30],
    // });
    const map = useMap();

    useEffect(() => {
        if (!map) return;
        const data = normalizeGeoConfig(options);
        map.setMaxBounds(data.bounds);
        map.setView(data.center, 12);

        map.setMaxZoom(data.maxZoom);
        map.setMinZoom(data.minZoom);
        map.setZoom(data.zoom);
    }, [options, map]);

    return <div></div>;
};
export default memo(OptionMap, (prev, next) =>
    isDeepEqual(prev.field.options, next.field.options),
);

function normalizeGeoConfig(config: ProcessFieldMap['options']): {
    center: LatLngExpression;
    bounds: LatLngBoundsExpression;
    zoom: number;
    maxZoom: number;
    minZoom: number;
} {
    // 👇 Безопасный парсер с защитой от NaN, null, undefined и ошибок
    const safeParse = (
        value: string | number | null | undefined,
        fallback: number,
    ): number => {
        const num =
            typeof value === 'string'
                ? parseFloat(value.replace(',', '.'))
                : Number(value);
        return isFinite(num) ? num : fallback;
    };

    console.log(config, 'config config');

    // ✅ Парсим и нормализуем точки
    const topLat = safeParse(config.topPoint?.lat, 0);
    const topLng = safeParse(config.topPoint?.lng, 0);
    const bottomLat = safeParse(config.bottomPoint?.lat, 0);
    const bottomLng = safeParse(config.bottomPoint?.lng, 0);

    const zoom = safeParse(config.zoom, 12);
    const maxZoom = safeParse(config.maxZoom, 18);
    const minZoom = safeParse(config.minZoom, 10);

    // ✅ Если нет centerPoint — вычисляем его автоматически
    const centerLat = config.centerPoint
        ? safeParse(config.centerPoint.lat, (topLat + bottomLat) / 2)
        : (topLat + bottomLat) / 2;

    const centerLng = config.centerPoint
        ? safeParse(config.centerPoint.lng, (topLng + bottomLng) / 2)
        : (topLng + bottomLng) / 2;

    // ✅ Если координаты перепутаны (например top < bottom) — переставляем
    const southWest: [number, number] = [
        Math.min(topLat, bottomLat),
        Math.min(topLng, bottomLng),
    ];
    const northEast: [number, number] = [
        Math.max(topLat, bottomLat),
        Math.max(topLng, bottomLng),
    ];

    return {
        center: [centerLat, centerLng],
        bounds: [southWest, northEast],
        zoom,
        maxZoom,
        minZoom,
    };
}
